import axiosClient from './axios-client';
import { API_ENDPOINTS } from '@/constants';

export type PaymentMethodKey =
  | 'stripe'
  | 'paypal'
  | 'npa'
  | 'send_request'
  | 'check'
  | 'bank_transfer'
  | 'zelle'
  | 'ach';

export type PaymentMethodFlags = Record<PaymentMethodKey, boolean>;

export const settingsApi = {
  getPaymentMethods: async (): Promise<PaymentMethodFlags> => {
    const response = await axiosClient.get(
      API_ENDPOINTS.SETTINGS_PAYMENT_METHODS,
    );
    return response.data;
  },
  updatePaymentMethods: async (
    update: Partial<PaymentMethodFlags>,
  ): Promise<PaymentMethodFlags> => {
    // Backend expects an enum-validated array of toggles, not a flat map.
    const methods = Object.entries(update).map(([method, enabled]) => ({
      method,
      enabled,
    }));
    const response = await axiosClient.patch(
      API_ENDPOINTS.SETTINGS_PAYMENT_METHODS,
      { methods },
    );
    return response.data;
  },
};
